<template>
  <div id="login">
    <div class="logo">
      <img src="@/assets/images/logo.png" alt="" />
    </div>
    <div class="content">
      <div class="left">
        <img src="@/assets/images/login.png" alt="" />
      </div>
      <div class="right">
        <div class="title">全病程管理运营系统</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item prop="username">
            <el-input
              placeholder="请输入账号"
              type="text"
              v-model="ruleForm.username"
              autocomplete="off"
              @input="inputChangeHandel"
              prefix-icon="iconfont icon-zhanghu"
              @keypress.native.enter="onEnterPress"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              placeholder="请输入密码"
              prefix-icon="iconfont icon-mima"
              type="password"
              v-model="ruleForm.password"
              autocomplete="off"
              @keypress.native.enter="onEnterPress"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import axios from 'axios'
//本地存储工具
import local from '@/utils/local.js'
import {judgeIsCustomer } from "@/views/newPatientmanage/api/treatmentPlan.js";


export default {
  data() {
    return {
      ruleForm: {
        grant_type: 'password',
        username: '',
        password: '',
      },
      rules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { min: 1, max: 30, message: '请输入账号', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 1, max: 20, message: '请输入密码', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    /**
     * @description: 
     * @param {*}
     * @return {*}
     */    
    inputChangeHandel(e){
        var reg = /[\u4e00-\u9fa5]/g;   
       this.ruleForm.username = e.replace(reg, "");
    },
    //按下回车键事件
    onEnterPress(){
      this.submitForm();
    },
    //登录按钮
    async submitForm() {
      let param = this.ruleForm
      if (
        param.username === '' ||
        param.password === '' ||
        param.grant_type === ''
      ) {
        return
      }
      await axios
        .post('auth/oauth/token', qs.stringify(param), {
          headers: {
            Authorization:
              'Basic ZHNpY20td2ViLW1hbmFnZXI6ZHNpY20td2ViLW1hbmFnZXItcHcjJCMlQA==',
          },
        })
        .then((res) => {
          if (res.data.code === 0) {
            let userid = res.data.data.user_id
            local.set('userid', userid) 
            judgeIsCustomer(userid).then(res=>{   
              local.set('isConsult', res.data)
            })
            let token =
              res.data.data.token_type + ' ' + res.data.data.access_token
            local.set('Authorization', token)
            local.set('socketToken',res.data.data.access_token)
            local.set('userInfoName', this.ruleForm.username)
            document.cookie = 'Authorization=' + `${token}`
            this.$router.push('/home')
            this.$message({
              message: '登陆成功',
              type: 'success',
            })
            this.$store.commit('GET_TOKEN', res.data.data.access_token)
          }
        }).catch(err=>{
          try {
            if (err.response.data.code > 0) {
              this.$message.error(err.response.data.message);
            } else {
              this.$message.error('网络异常，请稍后再试');
            }
          } catch (error) {
            this.$message.error('账号锁定，请稍后再试');
          }
        })
    },
  },
  sockets: {
    leftMenuNumber(datas) {
      if (datas.constructor === Object) {
        if (typeof datas === 'string') {
          this.$websocket.dispatch('getLeftMenuNumber', JSON.parse(datas))
        } else {
          this.$websocket.dispatch('getLeftMenuNumber', datas)
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
#login {
  position: relative;
  height: 100%;
  width: 100%;
  background-color: #666ee8;
  display: flex;
  justify-content: center;
  align-items: center;

  .logo {
    position: absolute;
    top: 15px;
    left: 15px;
    width: 60px;
    height: 60px;

    img {
      border: 5px solid #fff;
      border-radius: 50%;
      background-color: #fff;
      width: 50%;
      height: 50%;
    }
  }

  .content {
    display: flex;
    width: 800px;
    height: 400px;
    background: #fff;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 100px 30px;
    border-radius: 10px;
    box-shadow: 0 0 5px 2px rgb(44, 43, 43);

    .left {
      width: 50%;

      img {
        width: 100%;
      }
    }

    .right {
      width: 50%;

      .title {
        font-size: 26px;
        font-weight: 1000;
        margin-left: 100px;
        margin-bottom: 15px;
      }

      .find-pwd {
        display: flex;
        justify-content: space-between;
        margin-left: 100px;
        font-size: 12px;
        width: 100%;
        margin-top: 20px;
        margin-bottom: 15px;

        .left {
          margin-left: 20px;
        }

        .right {
          margin-left: 40px;
          cursor: pointer;
          color: rgb(0, 119, 255);
        }
      }

      .demo-ruleForm {
        width: 100%;

        .el-button {
          width: 100%;
        }
      }
    }
  }
  /deep/.el-input {
    width: 270px;
  }
}
</style>
